import { createAction, props } from '@ngrx/store';

import {
  AssetNetwork,
  GetAssetNetworksQuery,
  GetNetworksResponse,
  WhitelistAddress,
  WhitelistAddressMinimal,
  WhitelistAddressSort,
  BalanceHistoryData,
  BalanceHistoryPeriod,
} from '../models/asset-management.model';
import { PaginationResponse } from '@/app/shared/models/common.model';

export const loadNetworks = createAction('[Asset Management] Load Networks');

export const loadNetworksSuccess = createAction(
  '[Asset Management] Load Networks Success',
  props<{ response: GetNetworksResponse }>()
);

export const loadNetworksFailure = createAction(
  '[Asset Management] Load Networks Failure',
  props<{ error: string }>()
);

export const loadAssetNetworks = createAction(
  '[Asset Management] Load Asset Networks',
  props<{ query: GetAssetNetworksQuery }>()
);

export const loadAssetNetworksSuccess = createAction(
  '[Asset Management] Load Asset Networks Success',
  props<{ assetNetworks: AssetNetwork[] }>()
);

export const loadAssetNetworksFailure = createAction(
  '[Asset Management] Load Asset Networks Failure',
  props<{ error: string }>()
);

export const loadWhitelistAddresses = createAction(
  '[Asset Management] Load Whitelist Addresses'
);

export const loadWhitelistAddressesSuccess = createAction(
  '[Asset Management] Load Whitelist Addresses Success',
  props<{
    data: WhitelistAddress[];
    pagination: PaginationResponse;
  }>()
);

export const loadWhitelistAddressesFailure = createAction(
  '[Asset Management] Load Whitelist Addresses Failure',
  props<{ error: string }>()
);

/**
 * Fetch the network-scoped, minimal whitelist-address list used by the
 * wallet-detail "connect whitelist address" modal. Dispatched when the
 * user picks a value in the modal's network dropdown.
 */
export const loadWhitelistAddressesMinimal = createAction(
  '[Asset Management] Load Whitelist Addresses Minimal',
  props<{ assetNetworkId: string }>()
);

export const loadWhitelistAddressesMinimalSuccess = createAction(
  '[Asset Management] Load Whitelist Addresses Minimal Success',
  props<{ data: WhitelistAddressMinimal[] }>()
);

export const loadWhitelistAddressesMinimalFailure = createAction(
  '[Asset Management] Load Whitelist Addresses Minimal Failure',
  props<{ error: string }>()
);

/**
 * Reset the minimal whitelist-address slice so a re-opened modal does
 * not flash entries cached from a previous network filter.
 */
export const clearWhitelistAddressesMinimal = createAction(
  '[Asset Management] Clear Whitelist Addresses Minimal'
);

// Pagination Actions
export const setPage = createAction(
  '[Asset Management] Set Page',
  props<{ pageIndex: number }>()
);

export const setPageSize = createAction(
  '[Asset Management] Set Page Size',
  props<{ pageSize: number }>()
);

// Sort Actions
export const setSort = createAction(
  '[Asset Management] Set Sort',
  props<{ sort: WhitelistAddressSort }>()
);

// Filter Actions
export const setFilters = createAction(
  '[Asset Management] Set Filters',
  props<{ search: string }>()
);

export const clearFilters = createAction('[Asset Management] Clear Filters');

// Search Actions
export const setSearch = createAction(
  '[Asset Management] Set Search',
  props<{ searchTerm: string }>()
);
// Load Balance History Actions
export const loadBalanceHistory = createAction(
  '[Asset Management] Load Balance History',
  props<{ vaultId: string; walletId: string[]; period: BalanceHistoryPeriod }>()
);

export const loadBalanceHistorySuccess = createAction(
  '[Asset Management] Load Balance History Success',
  props<{ data: BalanceHistoryData }>()
);

export const loadBalanceHistoryFailure = createAction(
  '[Asset Management] Load Balance History Failure',
  props<{ error: string }>()
);
